// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// session.js
export const SET_SESSION = 'SET_SESSION'
export const SAVE_LAST_ACTIVITY = 'SAVE_LAST_ACTIVITY'
export const AUTO_SAVE_SESSION = 'AUTO_SAVE_SESSION'
export const RENEW_SESSION = 'RENEW_SESSION'
export const END_SESSION = 'END_SESSION'
export const SET_PARENT_VALUES = 'SET_PARENT_VALUES'
export const SUBSTRACT_LEFTTIME = 'SUBSTRACT_LEFTTIME'
export const RESTART_LEFTTIME = 'RESTART_LEFTTIME'
export const END_LEFTTIME = 'END_LEFTTIME'

// maintenance.js
export const SET_MAINTENANCE = 'SET_MAINTENANCE'
export const DISABLE_MAINTENANCE = 'DISABLE_MAINTENANCE'

// details.js
export const SET_FORM_INFORMATION = 'SET_FORM_INFORMATION'
export const SET_FORM_FILES = 'SET_FORM_FILES'
export const SET_FORM_FILE = 'SET_FORM_FILE'
export const SET_FORM_FILE_ERRORS = 'SET_FORM_FILE_ERRORS'
export const MARK_FORM_FILE_AS_VALIDATED = 'MARK_FORM_FILE_AS_VALIDATED'
export const MARK_FORM_FILE_AS_INVALID = 'MARK_FORM_FILE_AS_INVALID'
export const UPDATE_FORM_INFORMATION = 'UPDATE_FORM_INFORMATION'



// WEBPACK FOOTER //
// ./resources/js/store/mutation-types.js